export enum OrganisationUserInvitationStatusEnum {
  UNKNOWN = "unknown",
  PENDING = "pending",
  ACCEPTED = "accepted",
  CANCELLED = "cancelled",
  EXPIRED = "expired",
}
